import axios from "axios";
import { BACKEND_BASEURL } from "../../../db/baseUrl";
export const API_DAYSTART = `${BACKEND_BASEURL}api/dayStarts/`;

const getDayStatus = async () => {
  const response = await axios.get(API_DAYSTART + "getDayStatus");
  return response.data;
};
const startDay = async (openingBalance) => {
  const response = await axios.post(API_DAYSTART + "startDay", openingBalance);
  return response.data.dayStart;
};

const closeDay = async (closingBalance) => {
  const response = await axios.post(API_DAYSTART + "closeDay", closingBalance);
  return response.data.dayStart;
};

const getTillAmount = async () => {
  const response = await axios.get(API_DAYSTART + "getTillAmount");
  return response.data;
};

const DayStartServices = {
  getDayStatus,
  startDay,
  getTillAmount,
  closeDay,
};
export default DayStartServices;
